export const HEIGHT_UNITS = { meters: 'm', feets: 'ft.' };
